import { render, staticRenderFns } from "./ActionsCell.vue?vue&type=template&id=024a9d30"
import script from "./ActionsCell.vue?vue&type=script&lang=ts"
export * from "./ActionsCell.vue?vue&type=script&lang=ts"
import style0 from "./ActionsCell.vue?vue&type=style&index=0&id=024a9d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports